// extracted by mini-css-extract-plugin
export default {"editor":"editor__OcJ16j","editorWithSider":"editorWithSider__UMUhzu","buttonHighlight":"buttonHighlight__vKgXOD","documentRtl":"documentRtl__BeMCd0"};